import React from 'react';
import { Subtle } from '@xo-union/tk-ui-typography';

import styles from './styles.scss';

interface Props {
  children: string;
}

const SubtleHeading: React.FC<Props> = ({ children }) => (
  <div className={styles.container}>
    <Subtle>{children}</Subtle>
  </div>
);

export default SubtleHeading;
